// extracted by mini-css-extract-plugin
export default {"recos":"C6-z","productCardOverride":"D6-z","rowHasBadge":"E6-z"};